import { Divider, IconButton, Menu, MenuItem, Stack, Toolbar } from "@mui/material";
import useAuth from "../hooks/useAuth";
import Cookies from "js-cookie";
import React, { useEffect, useRef, useState } from "react";
import useQuickLinks from "../hooks/useQuickLinks";
import baseURL from "../../configs/api";
import useProfile from "../hooks/useProfile";
import QuickPickupSelectWrapper from "./QuickPickupSelectWrapper";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../hooks/useTheme";
import { iconValues } from "../../utils/iconValues";


const quickSearchItems = [
  "Booking",
  "Vehicle",
  "Customer"
]

export const TopBar = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const companyName = Cookies.get("companyName-jj-rental-ui") || "";
  const profileImg = Cookies.get("profileImg-jj-rental-ui") || "";
  const { toggleTheme, theme, themeStyles } = useTheme();
  const { auth, setAuth }: any = useAuth();
  const navigate = useNavigate();
  const { quickLinks, setQuickLinks }: any = useQuickLinks();
  const { setProfileOpen }: any = useProfile();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [quickAnchorEl, setQuickAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const openQuickSearch = Boolean(quickAnchorEl);
  const [selectedQuickSearch, setSelectedQuickSearch] = useState<string>(quickSearchItems[0]);
  const [pageNo, setPage] = useState<number>(-1);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [isNextPageLoading, setNextPageLoading] = useState<boolean>(false);
  const [options, setOptions] = useState([]);
  const [searchValue, setSearchValue] = useState<string>("");
  const [isSearching, setIsSearching] = useState<boolean>(false);
  const [placeholder, setPlaceholder] = useState<string>("Search By Booking No");
  const [openUser, setOpenUser] = useState<boolean>(false);
  const [loadingTheQuickLinks, setLoadingTheQuickLinks] = useState<boolean>(true);
  const [selectedOption, setSelectedOption] = useState<any>(null);
  const accountRef = useRef<HTMLDivElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickQuickSearch = (event: React.MouseEvent<HTMLButtonElement>) => {
    setQuickAnchorEl(event.currentTarget);
  };
  const handleCloseQuickSearch = () => {
    setQuickAnchorEl(null);
  };

  const logout = () => {
    setAuth(null);
    Cookies.remove("tenantId-jj-rental-ui");
    Cookies.remove("token-jj-rental-ui");
    Cookies.remove("roleId-jj-rental-ui");
    Cookies.remove("role-jj-rental-ui");
    Cookies.remove("userId-jj-rental-ui");
    Cookies.remove("isAdmin-jj-rental-ui");
    Cookies.remove("profileImg-jj-rental-ui");
    Cookies.remove("expires-jj-rental-ui");
    Cookies.remove("companyName-jj-rental-ui");
    sessionStorage.removeItem("vendorsTab");
  }

  useEffect(() => {
    setQuickLinks(quickLinks);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quickLinks])

  useEffect(() => {
    switch (selectedQuickSearch.trim().toLocaleLowerCase()) {
      case "booking":
        setPlaceholder("Search By Bookings No.");
        break;
      case "vehicle":
        setPlaceholder("Search By Vin or Licence Plate.");
        break;
      case "customer":
        setPlaceholder("Search By Customer Name.");
        break;

    }
  }, [selectedQuickSearch])

  useEffect(() => {
    let timeOutId: NodeJS.Timeout;
    if (searchValue !== "") {
      timeOutId = setTimeout(() => {
        setIsSearching(false);
        setOptions([]);
        setHasNextPage(true);
        setNextPageLoading(false);
        setPage(-1)
      }, 1000)
    } else {
      setOptions([]);
      setIsSearching(false);
      setHasNextPage(true);
      setNextPageLoading(false);
      setPage(-1);
    }

    return () => clearTimeout(timeOutId);
  }, [searchValue])

  const loadNextPage = () => {
    if (searchValue === "") {
      loadWithOutSearchOptions(pageNo + 1);
    } else {
      loadWithSearchOptions(pageNo + 1);
    }
  };

  const loadWithOutSearchOptions = (page: number) => {
    try {
      const pagination = {
        page: page,
        size: 15
      }
      setNextPageLoading(true);
      if (selectedQuickSearch.toLocaleLowerCase().trim() === 'booking') {
        fetch(`${baseURL}reservation/GetReservationsReportPaging/${pagination.page},${pagination.size}`,
          {
            method: 'GET',
            headers: {
              'X-Tenant-ID': tenantId,
              'Content-Type': 'application/json'
            }
          }
        )
          .then((res) => res.json())
          .then((data) => {
            const dataOptions = data.reservationReport.map((item: any) => {
              return {
                value: item.id,
                label: item?.bookingNumber,
              }
            })

            const itemsData = options.concat(dataOptions);
            setOptions(itemsData);
            setNextPageLoading(false);
            setHasNextPage(itemsData.length < data.count);
            setPage(page);
          })
          .catch((error) => {
            console.error(error)
          })
      } else if (selectedQuickSearch.toLocaleLowerCase().trim() === 'vehicle') {
        fetch(`${baseURL}vehicles/GetVehicleReportPaging/${pagination.page},${pagination.size}`,
          {
            method: 'GET',
            headers: {
              'X-Tenant-ID': tenantId,
              'Content-Type': 'application/json'
            }
          }
        )
          .then((res) => res.json())
          .then((data) => {
            const dataOptions = data.vehicleReports.map((item: any) => {
              return {
                value: item.id,
                label: item?.licensePlate,
              }
            })

            const itemsData = options.concat(dataOptions);
            setOptions(itemsData);
            setNextPageLoading(false);
            setHasNextPage(itemsData.length < data.count);
            setPage(page);
          })
          .catch((error) => {
            console.error(error)
          })
      } else {
        fetch(`${baseURL}Customer/GetCustomersPaging/${pagination.page},${pagination.size}`,
          {
            method: 'GET',
            headers: {
              'X-Tenant-ID': tenantId,
              'Content-Type': 'application/json'
            }
          }
        )
          .then((res) => res.json())
          .then((data) => {
            const dataOptions = data.customers.map((item: any) => {
              return {
                value: item.id,
                label: item?.firstName + " " + item?.lastName,
              }
            })

            const itemsData = options.concat(dataOptions);
            setOptions(itemsData);
            setNextPageLoading(false);
            setHasNextPage(itemsData.length < data.count);
            setPage(page);
          })
          .catch((error) => {
            console.error(error)
          })
      }
    } catch (error) {
      console.error(error);
    }
  }

  const loadWithSearchOptions = (page: number) => {
    try {
      const pagination = {
        page: page,
        size: 15
      }
      setNextPageLoading(true);
      if (selectedQuickSearch.toLocaleLowerCase().trim() === 'booking') {
        fetch(`${baseURL}reservation/GetReservationsReportSearchWithBookingNumber?bookingNumber=${searchValue}&page=${pagination.page}&size=${pagination.size}`,
          {
            method: 'GET',
            headers: {
              'X-Tenant-ID': tenantId,
              'Content-Type': 'application/json'
            }
          }
        )
          .then((res) => res.json())
          .then((data) => {
            const dataOptions = data.reservationReport.map((item: any) => {
              return {
                value: item.id,
                label: item?.bookingNumber,
              }
            })
            const itemsData = options.concat(dataOptions);
            setOptions(itemsData);
            setNextPageLoading(false);
            setHasNextPage(itemsData.length < data.count);
            setPage(page);
          })
          .catch((error) => {
            console.error(error)
          })
      } else if (selectedQuickSearch.toLocaleLowerCase().trim() === 'vehicle') {
        fetch(`${baseURL}vehicles/GetVehicleReportWithSearch?search=${searchValue}&page=${pagination.page}&size=${pagination.size}`,
          {
            method: 'GET',
            headers: {
              'X-Tenant-ID': tenantId,
              'Content-Type': 'application/json'
            }
          }
        )
          .then((res) => res.json())
          .then((data) => {
            const dataOptions = data.vehicleReports.map((item: any) => {
              return {
                value: item.id,
                label: item?.licensePlate,
              }
            })

            const itemsData = options.concat(dataOptions);
            setOptions(itemsData);
            setNextPageLoading(false);
            setHasNextPage(itemsData.length < data.count);
            setPage(page);
          })
          .catch((error) => {
            console.error(error)
          })
      } else {
        fetch(`${baseURL}Customer/GetCustomersSearchWithCustomerNamePaging?customerName=${searchValue}&page=${pagination.page}&size=${pagination.size}`,
          {
            method: 'GET',
            headers: {
              'X-Tenant-ID': tenantId,
              'Content-Type': 'application/json'
            }
          }
        )
          .then((res) => res.json())
          .then((data) => {
            const dataOptions = data.customers.map((item: any) => {
              return {
                value: item.id,
                label: item?.firstName + " " + item?.lastName,
              }
            })

            const itemsData = options.concat(dataOptions);
            setOptions(itemsData);
            setNextPageLoading(false);
            setHasNextPage(itemsData.length < data.count);
            setPage(page);
          })
          .catch((error) => {
            console.error(error)
          })
      }

    } catch (error) {
      console.error(error);
    }
  }

  const resetSearchState = () => {
    setSearchValue("");
    setOptions([]);
    setPage(-1);
    setHasNextPage(true);
    setIsSearching(false);
    setNextPageLoading(false);
    setSelectedOption(null);
  };


  const navigateToSelectDestination = (id: number) => {
    if (!id) return;

    switch (selectedQuickSearch.toLocaleLowerCase().trim()) {
      case 'booking':
        navigate(`/carrental/reservations/editreservation?id=${id}`);
        break;
      case 'vehicle':
        navigate("/fleet/vehicle/editvehicles", { state: id });
        break;
      case 'customer':
        navigate(`/contacts/customers/editcustomer?id=${id}`);
        break;
    }

    resetSearchState();
  };

  useEffect(() => {
    setLoadingTheQuickLinks(true);
    fetch(`${baseURL}QuickLinks/GetQuickLinksWithActive/true`,
      {
        method: 'GET',
        headers: {
          'X-Tenant-ID': tenantId,
          'Content-Type': 'application/json'
        }
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setQuickLinks(data);
        setLoadingTheQuickLinks(false);
      })
      .catch((error) => {
        setQuickLinks([]);
        setLoadingTheQuickLinks(false);
        console.error("Error fetching quickLinks:", error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLinkClick = (link: string, isNewTab: boolean) => {
    if (isNewTab) {
      window.open(link, '_blank');
    } else {
      window.location.href = link;
    }
  };

  return (
    <div className={`sticky top-0 z-[1002] w-full ${themeStyles.topBar.tailwindBg} border-b ${themeStyles.topBar.tailwindBorderColor}`}>
      <Toolbar sx={{ width: "100%", justifyContent: "space-between", paddingRight: '10px' }}>
        <div className="flex items-center gap-2.5 w-[500px]">
          <div >
            <button
              className={`flex items-center justify-between py-[5px] px-[12px] gap-2.5 rounded-lg border border-solid ${themeStyles.topBar.tailwindBorderColor}`}
              aria-controls={openQuickSearch ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openQuickSearch ? 'true' : undefined}
              onClick={handleClickQuickSearch}
            >
              <Stack
                direction="row"
                spacing={1}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <span className={`${themeStyles.topBar.tailwindTextColor} text-[16px] font-medium`}>{selectedQuickSearch}</span>
                {
                  openQuickSearch
                    ? <span className={`material-symbols-outlined ${themeStyles.topBar.tailwindTextColor} text-[25px] font-extralight`}>keyboard_arrow_up</span>
                    : <span className={`material-symbols-outlined ${themeStyles.topBar.tailwindTextColor} text-[25px] font-extralight`}>keyboard_arrow_down</span>
                }
              </Stack>
            </button>

            <Menu
              id="basic-menu"
              anchorEl={quickAnchorEl}
              open={openQuickSearch}
              onClose={handleCloseQuickSearch}
              slotProps={{
                paper: {
                  sx: {
                    width: 170,
                    backgroundColor: themeStyles.topBar.bg
                  }
                }
              }}
            >
              {
                quickSearchItems?.map((label, index) => ([
                  <MenuItem
                    key={`${index}-item`}
                    sx={{ fontSize: "12px", marginBlock: "0px" }}
                    onClick={() => {
                      setSelectedQuickSearch(label)
                      setQuickAnchorEl(null);
                      resetSearchState();
                    }}>
                    <span className={`${themeStyles.topBar.tailwindTextColor} text-[16px] font-medium`}>{label}</span>
                  </MenuItem>,
                  <Divider key={`${index}-divider`} className="w-full" />
                ]))
              }
            </Menu>
          </div>

          <div className="w-full">
            <QuickPickupSelectWrapper
              hasNextPage={hasNextPage}
              isNextPageLoading={isNextPageLoading}
              setSearchValue={setSearchValue}
              options={options}
              setPage={setPage}
              loadNextPage={loadNextPage}
              isSearching={isSearching}
              setIsSearching={setIsSearching}
              placeholder={placeholder}
              value={selectedOption}
              onChange={(searchValue: any) =>
                navigateToSelectDestination(searchValue?.value)
              }
            />
          </div>

          <button
            className="flex items-center justify-between p-[5px] gap-2.5 rounded-full border border-solid border-[#D0D0D0]"
            onClick={toggleTheme}
          >
            {theme === "dark" ? <span className={`material-symbols-outlined ${themeStyles.topBar.tailwindTextColor} text-[25px] font-light`}>
              dark_mode
            </span> : <span className={`material-symbols-outlined ${themeStyles.topBar.tailwindTextColor} text-[25px] font-light`}>
              light_mode
            </span>}
          </button>
        </div>

        <div className="flex justify-center max-w-[140px]">
          <span
            className="max-w-[140px] truncate text-[1rem] text-nowrap font-semibold text-[#167AC3] uppercase px-4 py-1 rounded-full bg-[#167AC326] backdrop-blur-sm tracking-wide shadow-sm"
            title={companyName}
          >
            {companyName}
          </span>
        </div>

        <div className="flex items-center gap-2.5">
          <div className="flex items-center gap-3.5">
            <a href="/support/support-tickets" className="group">
              <span className={`material-symbols-outlined ${themeStyles.topBar.tailwindTextColor}  text-[25px] font-extralight group-hover:scale-125 group-hover:text-[#167AC3]`}>
                help
              </span>
            </a>

            {
              !loadingTheQuickLinks
                ? (
                  quickLinks && quickLinks?.length > 0 && (
                    quickLinks
                      ?.filter((item: any) => item.isOnTopBar && item.isActive)
                      ?.map((item: any, index: number) => {
                        const iconData = iconValues?.find((icon) => icon?.value === item?.topBarIcon);

                        return iconData ? (
                          <button
                            key={index}
                            onClick={() => handleLinkClick(item?.link, item?.isOpenInNewTab)}
                            className="outline-none border-none bg-transparent group"
                          >
                            <span className={`material-symbols-outlined ${themeStyles.topBar.tailwindTextColor}  text-[25px] font-extralight group-hover:scale-125 group-hover:text-[#167AC3]`}>
                              {iconData.icon}
                            </span>
                          </button>
                        ) : null;
                      })
                  )
                ) : (
                  <span>Loading...</span>
                )
            }
          </div>

          <div>
            <button
              className="flex py-[5px] items-center gap-1.5 cursor-pointer"
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
            >
              <Stack
                direction="row"
                spacing={2}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <div ref={accountRef} className="flex">
                  <div
                    className="cursor-pointer"
                    onClick={() => setOpenUser(!openUser)}
                  >
                    {profileImg !== "" && profileImg !== "null" && profileImg !== "string" ? (
                      <IconButton aria-label="delete" size="large">
                        <img
                          className="w-[40px] h-[40px] rounded-full"
                          alt="profileImg"
                          src={`${baseURL}commonFile/Get?name=${profileImg}`}
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = "./images/profile-placeholder.png";
                          }}
                        />
                      </IconButton>
                    ) : (
                      <IconButton
                        aria-label="delete"
                        size="large"
                        sx={{
                          fontSize: "32px",
                        }}
                      >
                        <img src="./images/profile-placeholder.png" alt="profile_placeholder" className="w-[40px] h-[40px] rounded-full shadow-box-shadow-profile" />
                      </IconButton>
                    )}
                  </div>
                </div>

                <div className="flex flex-col gap-0.5">
                  <span className={`${themeStyles.topBar.tailwindTextColor} text-[14px] font-medium`}>{auth?.givenname}</span>
                  <span className={`${themeStyles.topBar.tailwindTextColor} text-[10px] font-semibold`}>{auth?.roles}</span>
                </div>

                {open ? <span className={`material-symbols-outlined ${themeStyles.topBar.tailwindTextColor} text-[25px] font-extralight`}>
                  keyboard_arrow_up
                </span> : <span className={`material-symbols-outlined ${themeStyles.topBar.tailwindTextColor} text-[25px] font-extralight`}>
                  keyboard_arrow_down
                </span>}
              </Stack>
            </button>

            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              slotProps={{
                paper: {
                  sx: {
                    width: 170,
                    backgroundColor: themeStyles.topBar.bg
                  }
                }
              }}
            >
              <MenuItem
                sx={{ fontSize: "12px", marginBlock: "0px", display: "flex", alignItems: "center" }}
                onClick={() => {
                  setProfileOpen(true);
                  setAnchorEl(null);
                }}>
                <span className={`material-symbols-outlined ${themeStyles.topBar.tailwindTextColor} text-[25px] font-extralight`}>account_circle</span>
                <span className={`${themeStyles.topBar.tailwindTextColor} text-[16px] font-medium ml-1`}>Profile</span>
              </MenuItem>

              <Divider className="w-full" />

              <MenuItem
                sx={{ fontSize: "12px", display: "flex", alignItems: "center" }}
                onClick={logout}
              >
                <span className={`material-symbols-outlined ${themeStyles.topBar.tailwindTextColor} text-[25px] font-extralight`}>logout</span>
                <span className={`${themeStyles.topBar.tailwindTextColor} text-[16px] font-medium ml-1`}>Logout</span>
              </MenuItem>
            </Menu>
          </div>
        </div>
      </Toolbar>
    </div>
  )
}